import React from "react";
import { createRoot } from "react-dom/client"; ///React v18.2
// import ReactDOM from 'react-dom';///React v17
import "./configs/configs.js";
import "./assets/css/index.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";

///For React V18
const root = createRoot(document.getElementById("root"));
root.render(<App />);
////Begin đăng ký Service Worker cho offline
// if ("serviceWorker" in navigator) {
//     window.addEventListener("load", () => {
//         navigator.serviceWorker
//             .register("/service-worker.js")
//             .then(() => {
//                 //console.log("🚀 Service Worker đã đăng ký thành công!");
//             })
//             .catch((error) => {
//                 //console.error("❌ Service Worker đăng ký thất bại:", error);
//             });
//     });
// }
////End đăng ký Service Worker cho offline
reportWebVitals();
